import api from './api'

export const createSpecialTask = async taskData => {
  try {
    const formData = new FormData()

    Object.keys(taskData).forEach(key => {
      if (key === 'photos' && Array.isArray(taskData[key])) {
         taskData[key].forEach(file => {
             formData.append('photos', file);
         });
      } 
      else if (key === 'photo' && taskData[key]) {
         formData.append('photos', taskData[key]); 
      }
      else {
        formData.append(key, taskData[key])
      }
    })

    const response = await api.post('/tache/add', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    return response.data
  } catch (err) {
    console.error('Error creating special task:', err)
    throw err
  }
}

export const getTasksByResort = async (resortId, sector = null) => {
  try {
    let url = `/tache/resort/${resortId}`;
    if (sector && sector !== 'all') {
      url += `?sector=${encodeURIComponent(sector)}`;
    }
    
    const response = await api.get(url)
    return response.data
  } catch (err) {
    console.error('Error fetching tasks for resort:', err)
    throw err
  }
}

// Get all pending tasks that need review
export const getPendingTasks = async resortId => {
  try {
    const response = await api.get(`/tache/pending/${resortId}`)
    return response.data
  } catch (err) {
    console.error('Error fetching pending tasks:', err)
    throw err
  }
}

// Get a specific task by ID
export const getTaskById = async id => {
  try {
    const response = await api.get(`/tache/${id}`)
    return response.data
  } catch (err) {
    console.error('Error fetching task:', err)
    throw err
  }
}

export const updateTask = async (id, taskData) => {
  try {
    // Handle file upload if included
    if (taskData.photo instanceof File) {
      const formData = new FormData()

      // Add all task data to formData
      Object.keys(taskData).forEach(key => {
        if (key === 'photo') {
          formData.append('photo', taskData[key])
        } else {
          formData.append(key, taskData[key])
        }
      })

      const response = await api.put(`/tache/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })

      return response.data
    } else {
      // Regular JSON update if no file
      const response = await api.put(`/tache/${id}`, taskData)
      return response.data
    }
  } catch (err) {
    console.error('Error updating task:', err)
    throw err
  }
}

export const deleteTask = async id => {
  try {
    const response = await api.delete(`/tache/${id}`)
    return response.data
  } catch (err) {
    console.error('Error deleting task:', err)
    throw err
  }
}

// Approve a task and add it to a plan
export const approveTask = async (id, planId, approverId) => {
  try {
    const response = await api.put(`/tache/${id}/approve`, {
      plan_id: planId,
      approver_id: approverId,
    })
    return response.data
  } catch (err) {
    console.error('Error approving task:', err)
    throw err
  }
}

export const rejectTask = async (id, reason) => {
  try {
    const response = await api.put(`/tache/${id}/reject`, {
      reason,
    })
    return response.data
  } catch (err) {
    console.error('Error rejecting task:', err)
    throw err
  }
}

// Get tasks for a specific grooming plan
export const getTasksByPlan = async planId => {
  try {
    const response = await api.get(`/tache/plan/${planId}`)
    return response.data
  } catch (err) {
    console.error('Error fetching tasks for plan:', err)
    throw err
  }
}

export const completeTask = async (id, completionNotes) => {
  try {
    const response = await api.put(`/tache/${id}/complete`, {
      completion_notes: completionNotes,
    })
    return response.data
  } catch (err) {
    console.error('Error completing task:', err)
    throw err
  }
}

// Get special tasks associated with a plan
export const getSpecialTasksForPlan = async planId => {
  try {
    if (!planId) return []

    const response = await api.get(`/tache/plan/${planId}`)
    return response.data || []
  } catch (err) {
    console.error('Error fetching special tasks for plan:', err)
    return []
  }
}

export const getHistoricalSpecialTasks = async (resortId, date) => {
  try {
    const response = await api.get(`/tache/historical/${resortId}`, {
      params: { date },
    })
    return response.data
  } catch (err) {
    console.error('Error fetching historical special tasks:', err)
    throw err
  }
}

export const getRelevantTasksForPlan = async (planId, resortId) => {
  try {
    const response = await api.get(
      `/tache/plan/${planId}/relevant?resort_id=${resortId}`,
    )
    return response.data
  } catch (err) {
    console.error('Error fetching relevant tasks for plan:', err)
    throw err
  }
}

export const removeTaskFromPlan = async (taskId, planId) => {
  try {
    const response = await api.delete(`/tache/${taskId}/plan`, {
      data: { planId },
    })
    return response.data
  } catch (err) {
    console.error('Error removing task from plan:', err)
    throw err
  }
}
